/* eslint-disable no-param-reassign */
import { api } from "jiffy-api";
import { createStore } from "vuex";
import { useDtfStore } from "components/jiffy/vue-product-details-dtf/store";
import artworkModule from "./artwork-module";
import artworkModuleAbMadeMonetization from "./artwork-module-ab";
import checkoutModule from "./checkout-module";
import creationModule from "./creation-module";
import deliveryModule from "./delivery-module";
import surfaceModule from "./surface-module";
import appModule from "./app-module";
import productModule from "./product-module";

const initialState = {
  config: {},
  userType: "guest_user",
  artworkHistoryModalIndex: undefined,
  canvaSettings: null
};

const store = createStore({
  state() {
    return { ...initialState };
  },
  getters: {
    config: state => state.config,
    userType: state => state.userType,
    artworkHistoryModalIndex: state => state.artworkHistoryModalIndex,
    experiments: (_, getters) => getters.config?.experiments || {},
    canvaSettings: state => state.canvaSettings
  },
  mutations: {
    setUserType(state, userType) {
      state.userType = userType;
    },
    setConfig(state, value) {
      state.config = value;
    },
    setArtworkHistoryModalIndex(state, value) {
      state.artworkHistoryModalIndex = value;
    }
  },
  actions: {
    async loadCanvaSettings({ state }) {
      try {
        const settings = await api.canva.settings({
          source: "dtf",
          redirect_url: window.location.pathname
        });
        state.canvaSettings = settings;
      } catch (e) {
        console.error(e);
      }
    },
    resetState() {
      const dtfStore = useDtfStore();
      dtfStore.$state.artworksState = [
        { ...dtfStore.simulation, id: 0, index: 0 },
        { ...dtfStore.simulation, id: 1, index: 1 }
      ];
    }
  },
  modules: {
    artwork_front: document.querySelector(".js-ab-made-monetization-enabled")
      ? artworkModuleAbMadeMonetization
      : artworkModule,
    artwork_back: document.querySelector(".js-ab-made-monetization-enabled")
      ? artworkModuleAbMadeMonetization
      : artworkModule,
    surface_front: surfaceModule,
    surface_back: surfaceModule,
    checkout: checkoutModule,
    creation: creationModule,
    delivery: deliveryModule,
    product: productModule,
    app: appModule
  }
});

window.jiffy ||= {};
window.jiffy.madeStore = store;
export default store;
